@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}
<div kb-layout="grid">
  @for (card of attributes.cards; track card) {
    <section kb-card
      kb-grid-item-columns="4" kb-next-grid-row="related"
      [appEditorId]="card.editorId"
    >
      <app-plain-image slot="picture"
        [section]="card.attributes.medium"
      ></app-plain-image>
      <!-- TODO: implement subline, or remove from fs template -->
      <h3 slot="title" kb-heading type="bar" [appEditorId]="card.editorIds?.headline">{{card.attributes.headline}}</h3>
      <div slot="content">
        @if (card.attributes.subline) {
          <h4 kb-heading [appEditorId]="card.editorIds?.subline">{{card.attributes.subline}}</h4>
        }
        <p kb-paragraph [appEditorId]="card.editorIds?.text">{{ card.attributes.text }}</p>
        @if (card.attributes.link) {
          <a kb-standalone-link class="more-link"
            [appEditorId]="card.attributes.link.editorId"
            [kbRouterOrExternalLink]="card.attributes.link.attributes.url"
            [attr.target]="card.attributes.link.attributes.target"
          >
            @if (card.attributes.link.attributes.label) {
              {{ card.attributes.link.attributes.label }}
            } @else {
              <ng-container i18n="content teaser read more link@@2827984212740060090">Read more</ng-container>
            }
          </a>
        }
      </div>
    </section>
  }
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
